const mediaItems = [
  {
    title: '《繁花》沪上风云 · 时代精品',
    desc: '王家卫导演首部电视剧，胡歌领衔主演，讲述上海90年代商海传奇，画面如电影般精致。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20Chinese%20period%20drama%20poster%20style%20with%20Shanghai%20cityscape%20in%20the%201990s%2C%20retro%20neon%20lights%2C%20golden%20warm%20tones%2C%20film%20noir%20aesthetic%2C%20elegant%20character%20silhouettes%2C%20dramatic%20lighting%20on%20dark%20background&width=400&height=560&seq=media-fanhua&orientation=portrait',
    tag: '热播国剧',
  },
  {
    title: '《狂飙》扫黑风暴 · 口碑炸裂',
    desc: '张译张颂文双影帝飙戏，真实案件改编，层层反转揭露黑恶势力，年度现象级剧王。',
    img: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20poster%20with%20two%20male%20protagonists%20facing%20off%2C%20dark%20urban%20atmosphere%2C%20dramatic%20shadow%20and%20light%20contrast%2C%20police%20versus%20underworld%20theme%2C%20gritty%20realistic%20tone%2C%20deep%20contrast%20lighting&width=400&height=560&seq=media-kuangbiao&orientation=portrait',
    tag: '口碑神作',
  },
  {
    title: '《三体》科幻巨制 · 视听盛宴',
    desc: '刘慈欣原著改编，顶级特效打造宇宙级科幻史诗，人类文明与三体世界的首次碰撞。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20Chinese%20drama%20poster%20with%20cosmic%20elements%2C%20distant%20galaxies%20and%20stars%2C%20three%20suns%20in%20the%20sky%2C%20mysterious%20alien%20civilization%20vibe%2C%20deep%20space%20blue%20and%20purple%20tones%20on%20black%20background&width=400&height=560&seq=media-santi&orientation=portrait',
    tag: '科幻巨制',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-movie-2-line text-primary-500 text-sm"></i>
            <span className="text-primary-400 text-xs font-medium">精选推荐</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">本周媒体热推</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            编辑精选三部必看剧集，画质高清秒开即播，带来影院级观影享受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-500/30 transition-all"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="400"
                  height="560"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-950 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h4 className="text-foreground-800 font-heading font-bold text-sm mb-2">{item.title}</h4>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}